import { useState } from 'react';
import { Button, Dialog, FormControl } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CloseModalButton from '../../../../components/CloseModalButton';
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from '../../../../components/Dialog.styled';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

type ItemStatus = 'used' | 'inUse';

type Props = {
  open: boolean;
  itemStatus: ItemStatus;
  handleClose: () => void;
  handleSubmit: (usedDate: string | null) => void;
};

const ActiveInactiveModal: React.FC<Props> = ({ open, itemStatus, handleClose, handleSubmit }) => {
  const [usedDate, setUsedDate] = useState<string | null>(String(dayjs()));
  const title = itemStatus === 'used' ? 'Mark as In Use' : 'Mark as Used';
  const isDisabled = itemStatus === 'inUse' && !!!usedDate;

  return (
    <Dialog maxWidth="sm" fullWidth={true} open={open} onClose={handleClose}>
      <CloseModalButton handleClose={handleClose} />
      <StyledDialogTitle>{title}</StyledDialogTitle>
      <StyledDialogContent>
        <div className="m-t-16 m-b-16 m-l-8 m-r-8 flex flex-center">
          {itemStatus === 'used' && <div>Are you sure you'd like to mark this item as In Use?</div>}
          {itemStatus === 'inUse' && (
            <FormControl fullWidth>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en">
                <DatePicker
                  label="Date Used"
                  value={dayjs(usedDate) ?? ''}
                  maxDate={dayjs()}
                  onChange={(newDate) => setUsedDate(String(newDate))}
                  format="MM-DD-YYYY"
                  slotProps={{
                    textField: {
                      size: 'small',
                    }
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          )}
        </div>
      </StyledDialogContent>
      <StyledDialogFooter>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={() => handleSubmit(usedDate)} variant="contained" disabled={isDisabled}>
          Save
        </Button>
      </StyledDialogFooter>
    </Dialog>
  );
};

export default ActiveInactiveModal;
